// Determines if the user is nearing the bottom of the scored list.
// True when there are enough ranks to be meaningful, the winners are
// off screen, and either:
//   - the last rank is visible, OR
//   - the remaining scroll is less than one viewport height

let MIN_RANKS = 4;

export let getIsFinalApproach = ({
  rankCount,
  inLastRank,
  inLastPage,
  winnersVisible,
}: {
  rankCount: number;
  inLastRank: boolean;
  inLastPage: boolean;
  winnersVisible: boolean;
}) => {
  if (rankCount <= MIN_RANKS) return false;
  if (winnersVisible) return false;
  return inLastRank || inLastPage;
};
